import { ApiEndpointConfig } from './api-endpoint-config';

const ENDPOINTS: Record<string, ApiEndpointConfig> = {
  updateSession: {
    method: 'put',
    url: 'session/{sessionId}'
  },
  createConversation: {
    method: 'post',
    url: 'conversation/create',
    showSpinner: false
  },
  mergeSessionBP: {
    method: 'post',
    url: 'session/{sessionId}/merge'
  }
};

// Programmatically add serviceType to all endpoints
Object.values(ENDPOINTS).forEach((api) => {
  (api as any).serviceType = 'companion';
});

export const COMPANION_API_CONSTANTS = ENDPOINTS as typeof ENDPOINTS &
  Record<keyof typeof ENDPOINTS, { serviceType: string }>;
